export interface HoverTarget {
  seriesIndex?: number;
  dataIndex?: number;
}

/**
 * Opens a tooltip only after the pointer rests on an item, so sweeping across a
 * chart does not flash one. Once open, moving to another item updates it at once.
 */
export function createHoverIntent({
  delay,
  show,
  hide,
  /** Grace period for moving between neighbouring items without closing. */
  gap = 80,
}: {
  delay: number;
  show: (target: HoverTarget) => void;
  hide: () => void;
  gap?: number;
}) {
  let showTimer: ReturnType<typeof setTimeout> | undefined;
  let hideTimer: ReturnType<typeof setTimeout> | undefined;
  let open = false;
  const close = () => {
    clearTimeout(showTimer);
    clearTimeout(hideTimer);
    if (open) hide();
    open = false;
  };
  return {
    over(target: HoverTarget) {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
      const reveal = () => {
        open = true;
        show(target);
      };
      if (open) reveal();
      else showTimer = setTimeout(reveal, delay);
    },
    out() {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
      hideTimer = setTimeout(close, gap);
    },
    /** Pointer left the chart. */
    leave: close,
    dispose() {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    },
  };
}
